import compose from 'recompose/compose';
import when from 'recompose/branch';
import withState from 'recompose/withState';
import withProduct from './withProduct';
import withCountry from './withCountry';

const withValidationData = compose(
  when(props => !props.product || !props.productId, withProduct, c => c),
  when(props => !props.country, withCountry, c => c),
  withState('isSubmitting', 'setSubmitting', false),
);

export default withValidationData;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withValidationData.js